var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.popupParam.ramTechniqueCd === "RT00000040"
    ? _c("c-tab", {
        attrs: {
          type: "horizon",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          height: _vm.tabHeight,
          dense: "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (tab) {
                return [
                  _c(tab.component, {
                    tag: "component",
                    attrs: {
                      popupParam: _vm.param,
                      assessPlan: _vm.assessPlan,
                      attachInfo: _vm.attachInfo,
                      imprTabInfo: _vm.imprTabInfo,
                      disabled: _vm.disabled,
                      contentHeight: _vm.tabHeight,
                    },
                    on: {
                      "update:assessPlan": function ($event) {
                        _vm.assessPlan = $event
                      },
                      "update:assess-plan": function ($event) {
                        _vm.assessPlan = $event
                      },
                      "update:attachInfo": function ($event) {
                        _vm.attachInfo = $event
                      },
                      "update:attach-info": function ($event) {
                        _vm.attachInfo = $event
                      },
                      "update:imprTabInfo": function ($event) {
                        _vm.imprTabInfo = $event
                      },
                      "update:impr-tab-info": function ($event) {
                        _vm.imprTabInfo = $event
                      },
                      "update:disabled": function ($event) {
                        _vm.disabled = $event
                      },
                      getDetail: _vm.getDetail,
                      keySetting: _vm.keySetting,
                      closePopup: _vm.closePopup,
                      apprTitle: _vm.apprTitle,
                    },
                  }),
                ]
              },
            },
          ],
          null,
          false,
          3117654387
        ),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      })
    : _c("c-step", {
        attrs: {
          stepperGrpCd: "RAM_RISK_STEP_CD",
          currentStepCd: _vm.popupParam.ramStepCd,
          param: _vm.param,
          isCustomHeight: true,
          stepperHeight: "900px",
        },
        on: {
          stepBystep: _vm.stepBystep,
          keySetting: _vm.keySetting,
          research: _vm.research,
          stepClick: _vm.stepClick,
          closePopup: _vm.closePopup,
        },
        model: {
          value: _vm.ramStepCd,
          callback: function ($$v) {
            _vm.ramStepCd = $$v
          },
          expression: "ramStepCd",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }